import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { actionShared } from '../../containers/Widget/actions.js';

import ShareButton from './ShareButton';
import MailIcon from '../Svg/MailIconFooter';
import Link from './Link';

import { copyFor } from '../../copy/copy';

const getMailUrl = (publisherName, actionType, articleUrl, isEmbed, widgetRequestId) => {
    if (isEmbed) {
        articleUrl += `?widgetId=${widgetRequestId}`;
    }

    const subject = copyFor('sharing', 'mailSubject', actionType, undefined, {
        publisherName
    });
    const body = copyFor('sharing', 'mailBody', actionType, undefined, {
        publisherName,
        articleUrl
    });
    return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
        body
    )}`;
};

const MailShare = props => (
    <Link
        href={getMailUrl(
            props.publisherName,
            props.actionType,
            props.shareUrl,
            props.isEmbed,
            props.widgetRequestId
        )}
        onClick={() => props.actionShared('mail')}
        target="_blank"
        title={copyFor('sharing', 'mail')}
    >
        <ShareButton>
            <MailIcon />
        </ShareButton>
    </Link>
);

MailShare.propTypes = {
    actionShared: PropTypes.func.isRequired,
    actionType: PropTypes.string.isRequired,
    isEmbed: PropTypes.bool.isRequired,
    publisherName: PropTypes.string.isRequired,
    shareUrl: PropTypes.string.isRequired,
    widgetRequestId: PropTypes.string.isRequired
};

export default connect(
    state => ({
        actionType:
            state.router.location.pathname !== '/multiActionsCard' &&
            state.router.location.pathname !== '/targetedMultiAction' &&
            state.router.location.pathname !== '/singleAction'
                ? state.widget.activeAction.type
                : 'multipleActions',
        publisherName:
            state.widget.twitterMention !== undefined
                ? '@' + state.widget.twitterMention
                : state.widget.publisherName || 'Speakable',
        shareUrl: state.widget.articleUrl
    }),
    {
        actionShared
    }
)(MailShare);
